import React from 'react';
import { get, map, sortBy } from 'lodash';

import { ICategory } from '@/models';

import Accordion from '@/components/v2/UI/Accordion';

import useQueryParams from '@/hooks/useQueryParams';
import { useFilterHandler } from '@/hooks/products/use-filter-handler';
import Checkbox from '@/components/v2/Forms/Checkbox';
import { useTranslation } from 'react-i18next';

interface Props {
  relatedCategories: ICategory[];
  label: string;
}

const RelatedCategoriesFilter: React.FC<Props> = ({
  relatedCategories,
  label
}) => {
  const [query] = useQueryParams();
  const handler = useFilterHandler();
  const { t } = useTranslation();

  const categories = sortBy(
    sortBy(
      map(relatedCategories, relatedCategory => ({
        label: relatedCategory.category_name,
        value: relatedCategory.id_category
      })),
      'name',
      'value'
    )
  );

  if (categories.length === 0) {
    return null;
  }
  const variableName =
    'related' + String(label).charAt(0).toUpperCase() + String(label).slice(1);

  const selectedRelatedCategories = Object.keys(query).includes(variableName)
    ? Array.isArray(query[variableName])
      ? query[variableName]
      : [query[variableName]]
    : [];
  return (
    <Accordion
      as="ul"
      key={variableName}
      name={t('FILTERS.' + label)}
      className="px-6 py-3 space-y-3 xl:px-0"
    >
      {categories.map(({ label, value }) => (
        <li key={value}>
          <Checkbox
            name={variableName}
            checked={Boolean(
              selectedRelatedCategories
                ? selectedRelatedCategories.includes(value.toString())
                : false
            )}
            onChange={handler(value.toString())}
          >
            {label}
          </Checkbox>
        </li>
      ))}
    </Accordion>
  );
};

export default RelatedCategoriesFilter;
